import React, { useState, useEffect } from "react";
import Header from "../include/header";
import Footer from "../include/footer";
import LeftPanel from "../include/leftpanel";
import axios from "axios";
import Global from "../../APIConfig";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import AuthUser from "../../AuthUser";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Barcode from "../../Barcode";
import QRCode from 'qrcode.react';
const ShipmentLabelNew = () => {

    let navigate = useNavigate();
    const useQuery = () => {
        return new URLSearchParams(useLocation().search);
      };
    const query = useQuery();
    const slipno = query.get('slipno');
    const [list, setList] = useState([]);
    const { headers1, headers2, logout } = AuthUser();
    const [defaultlogo, setDefaultlogo] = useState('');
    const [loading, setloading] = useState(false);

    useEffect(() => {
        GetLabel();
        Getsystemdefaultlogo();
    }, []);
    const GetLabel = () => {
        axios({
            method: 'post',
            url: Global.baseUrl + 'ShipmentLabel',
            headers: headers1,
            data: {
                slip_no: slipno
            }
        })
            .then(function (response) {
                if (response.data.status == 200) {
                    var data = response.data.value;
                    setList(data);
                }
            })
            .catch(function (error) {
                if (error.response.status == 401) {
                    toast.error(error.response.statusText);
                    logout();
                    navigate('/');
                    window.location.reload();
                }
                // console.log(error);
            });
    }
    const Getsystemdefaultlogo = () =>
      {
        axios({
          method: 'post',
          url: Global.baseUrl+'systemdefaultlogo',
          data: {
          }
        })
        .then(function (response) {
          if(response.data.status == 200)
          {
            setDefaultlogo(response.data.value);
          }
          else
          {
            setloading(false);
            setDefaultlogo('');
          }
        })
        .catch(function (error) {
          setloading(false);
          console.log(error);
        });
      }


  const styles = {
    page: {
      width: '210mm',
      height: '297mm',
      padding: '10mm',
      margin: '0 auto',
      backgroundColor: 'white',
      fontFamily: "Arial, sans-serif",
      fontSize: "10px",
      // Print-specific styles
      '@media print': {
        margin: '0',
        padding: '0',
        boxShadow: 'none',
      }
    },
    labelsContainer: {
      display: 'flex',
      flexDirection: 'column',
    //   height: '100%',
      justifyContent: 'space-between',
      // For print view
      '@media print': {
        height: '277mm', // 297mm - 10mm top/bottom padding
      }
    },
    label: {
      border: '1px solid black',
    //   padding: '10px',
      width: "100%",
      boxSizing: 'border-box',
    //   marginBottom: '5mm',
      // Ensure labels take equal space in print view
      '@media print': {
        height: '133mm', // Half of available space minus some gap
        marginBottom: '5mm',
      }
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    companylogo: {
      fontWeight: "bold",
      fontSize: "18px",
      width: "50%",
    //   border: "1px solid black"
    },
    tracking: {
      width: "50%",
      border: "1px solid black",
      padding: "5px 0px",
      textAlign: "center"
    },
    trackingh2: {
      margin: "0",
      fontSize:"25px"
    },
    section: {
      border: '1px solid black',
      display: 'flex',
      marginTop: "10px"
    },
    shipperConsignee: {
      display: 'flex',
      justifyContent: "space-between",
      height:"20%"
    },
    column: {
      width: '48%',
      display: 'flex',
    },
    shipmentcontent: {
      border: "1px solid black",
      marginTop: "10px",
      textAlign: "center"
    },
    shipmentcontenttable: {
      width: "100%",
      borderCollapse: "collapse",
      marginTop: "10px",
    },
    shipmentcontentth: {
      border: "1px solid black",
      padding: "4px",
      textAlign: "left",
      fontWeight: "bold"
    },
    shipmentcontenttd: {
      border: "1px solid black",
      padding: "4px",
      textAlign: "left"
    },
    barcode: {
      textAlign: "center",
      fontSize: "20px",
      letterSpacing: "5px",
      margin: "10px 0",
    },
    signature: {
      border: "1px solid black",
      padding: "10px",
      marginTop: "10px",
      width: "50%"
    },
    footer: {
      textAlign: "center",
      marginTop: "10px",
      border: "1px solid black",
      fontSize: "8px",
      padding: "4px",
    },
    tearline: {
      textAlign: "center",
      margin: "2mm 0",
      fontFamily: "monospace",
    //   display: 'none', // Hide in normal view
      '@media print': {
        display: 'block', // Show only in print
        color: 'lightgray',
      }
    },
    barCode_Sec: {
    //   padding: "10px",
      marginTop: "10px",
      border: "1px solid black",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "50%",
    },
    barCode: {
      width: "90%",
      height: "50%"
    },
    logo_img: {
        width: "8rem",
        // filter: grayscale(1),
        margin: "0.5rem"
    },
    noOfBox: {
      textAlign: "center",
      width: "50%"
    },
    origin: {
      width: "50%"
    },
    lastSec: {
      display: "flex"
    },
    vrtcl_txt: {
      border: "1px solid black",
      padding: "2px",
      background: "gray",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginRight: "5px",
      height:"100%"
    },
    // Print-specific styles
    printStyles: {
      '@media print': {
        size: 'A4 portrait',
        margin: '0',
        padding: '0',
        // Ensure page breaks are handled properly
        pageBreakAfter: 'always',
        pageBreakInside: 'avoid',
      }
    },
    pfontsize:{
        fontSize:"10px"
    },
    pfontsize1:{
        margin:"0px"
    }
  };

  const renderLabel = (item) => (
    <div style={styles.label}>
      <div style={styles.header}>
        <div style={styles.companylogo}>
             <img style={styles.logo_img} src={`${Global.logoUrl}${defaultlogo}`} />
        </div>

        <div style={styles.tracking}>
          <h2 style={styles.trackingh2}>{item[0].slip_no}</h2>
          <div>DATE: {item[0].entrydate}</div>
        </div>
      </div>

      <div style={styles.section}>
        <div style={styles.origin}>
          <strong>Origin : {item[0].sendercountry}</strong>
        </div>
        <div style={styles.noOfBox}>
          <strong>BOX NO. 1</strong>
        </div>
      </div>

      <div style={{...styles.shipperConsignee, ...styles.section}}>
        <div style={styles.column}>
          <div style={styles.vrtcl_txt}>
            <strong>
              S<br /> 
              H<br />
              I<br />
              P<br />
              P<br />
              E<br />
              R<br />
            </strong>
          </div>        
          <p style={styles.pfontsize}>        
          {item[0].sender_name}<br />
          {item[0].sender_address}<br />
          {item[0].sendercountry}<br />
            TEL: {item[0].sender_phone}<br />
          </p>
        </div>
        <div style={styles.column}>
          <div style={styles.vrtcl_txt}>
            <strong>
              C<br />
              O<br />
              N<br />
              S<br />
              I<br />
              G<br />
              N<br />
              E<br />
              E<br />
            </strong>
          </div>
          <p style={styles.pfontsize}>        
          {item[0].reciever_name}<br />
          {item[0].reciever_address}<br />
          {item[0].receivercountry}<br />
            TEL: {item[0].reciever_phone}<br />
          </p>
        </div>
      </div>

      <div style={styles.shipmentcontent}>
        <p style={styles.pfontsize1}>Shipment Content</p>
        <table style={styles.shipmentcontenttable}>
          <tbody>
            <tr>
              <th style={styles.shipmentcontentth}>SERVICE TYPE</th>
              <td style={styles.shipmentcontenttd}>{item[0].services_name}</td>
              <th style={styles.shipmentcontentth}>VALUE</th>
              <td style={styles.shipmentcontenttd}>{item[0].declared_charge}</td>
            </tr>
            <tr>
              <th style={styles.shipmentcontentth}>NO. OF PIECES</th>
              <td style={styles.shipmentcontenttd}>BOX NO. 1</td>
              {/* <th style={styles.shipmentcontentth}>TERM</th> */}
              {/* <td style={styles.shipmentcontenttd}>DDU</td> */}
            </tr>
            <tr>
              <th style={styles.shipmentcontentth}>WEIGHT (KG) & DIMENSION</th>
              <td style={styles.shipmentcontenttd}>({item[0].weight}Kgs, {item[0].height}x{item[0].width}x{item[0].length}) (Dim Wt. {item[0].volumetric_weight}Kg)</td>
              <th style={styles.shipmentcontentth}>CHRG. WEIGHT</th>
              <td style={styles.shipmentcontenttd}>{item[0].volumetric_weight} KG</td>
            </tr>
            {/* <tr>
              <th style={styles.shipmentcontentth}>CONTENTS</th>
              <td colSpan="3" style={styles.shipmentcontenttd}>{item[0].weight}</td>
            </tr> */}
          </tbody>
        </table>
      </div>
      <div style={styles.lastSec}>
        <div style={styles.barCode_Sec}>
            <Barcode value={item[0].slip_no}/> 
        </div>

        <div style={styles.signature}>
          I/WE CONFIRM RECEIVED THE PACKAGES IN GOOD CONDITIONS.<br />
          NAME: _______________________<br />
          SIGNATURE & DATE: _______________________
        </div>
      </div>
      <div style={styles.footer}>
        GURKHA EXPRESS PTY. LTD. 24 GOOD STREET, GRANVILLE 2142, NSW, AUSTRALIA
      </div>
    </div>
  );

  return (
    <>
    {list != undefined ? 
        <>
        {list.map((ship,index)=>{
            return(
            <div style={{...styles.page, ...styles.printStyles}}>
                <div style={styles.labelsContainer}>
                    {renderLabel(list)}
                    <div style={styles.tearline}>-----------------------------TEAR HERE-----------------------------</div>
                    {renderLabel(list)}
                </div>
            </div>
            );
        })}
        </>
    :
    ""
    }
</>
  );
};

export default ShipmentLabelNew;